import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"
import * as PathUI from "../ui/PathUI"
import PreviewPathResource from "./PreviewPathResource"
import PreviewPathStep from "./PreviewPathStep"

const PreviewPathLesson = ({ pathItem }) => {
  return (
    <PathUI.PathLessonContainer>
      <PathUI.PathLessonHeader id={`lesson-${pathItem.id}`}>
        <Text.H4 inverted>{pathItem.name}</Text.H4>
        <Text.Meta inverted>{pathItem.description}</Text.Meta>
      </PathUI.PathLessonHeader>
      <PathUI.PathLessonGrid>
        {pathItem.items.map((pathItem) => (
          <li key={pathItem.id}>
            {pathItem.type === "resource" ? (
              <PreviewPathResource pathItem={pathItem} layout="grid" />
            ) : pathItem.type === "step" ? (
              <PreviewPathStep pathItem={pathItem} />
            ) : null}
          </li>
        ))}
      </PathUI.PathLessonGrid>
    </PathUI.PathLessonContainer>
  )
}

PreviewPathLesson.displayName = "PreviewPathLesson"

PreviewPathLesson.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default PreviewPathLesson
